export const UNIT_OFFER_PRICE = 600;
export const UNIT_OFFER_CURRENCY = "EUR";

export const unitOfferCopy = {
  en: { label: "Special offer", amount: "€600", unit: "per unit" },
  es: { label: "Oferta especial:", amount: "600 €", unit: "por unidad" },
  fr: { label: "Offre spéciale :", amount: "600 €", unit: "par unité" },
  de: { label: "Sonderangebot:", amount: "600 €", unit: "pro Stück" },
  sv: { label: "Specialerbjudande:", amount: "600 €", unit: "per enhet" },
  ar: { label: "عرض خاص:", amount: "600 يورو", unit: "للوحدة" },
};